var React = require('react');

function Facebook (props) {
    return React.createElement("svg",props,React.createElement("path",{"fill":"currentColor","d":"m12.766 15.64.679-4.749H9.192V7.805c0-1.299.596-2.567 2.5-2.567h1.933V1.194S11.865.875 10.19.875c-3.505 0-5.798 2.278-5.798 6.396v3.62H.5v4.749h3.892v11.485h4.793V15.64z"}));
}

Facebook.defaultProps = {"fill":"none","viewBox":"0 0 14 28"};

module.exports = Facebook;

Facebook.default = Facebook;
